Fancybox.bind("[data-fancybox]", {
    Toolbar: false,
    closeButton: "top",
    autoFocus : false,
  });
  Fancybox.bind('[data-fancybox="spende"]', {
    Toolbar: {
      enabled: true,
      display: {
        left: [],
        middle: [],
        right: ["close"],
      },
    },
  });
    Fancybox.bind('[data-fancybox="happy-tesla"]', {
    Toolbar: false,
    closeButton: "top",
    autoFocus : false,
  });